<ng-container *ngIf="ready == false">
  <mat-card appearance="outlined">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
  </mat-card>
</ng-container>

<ng-container *ngIf="ready">

  <ng-container *ngIf="depositSaved === false">
    <div class="row mb-3">
      <div class="col-4">
        <p>
          <strong>Constitución préstamo {{ tittle }}</strong>
        </p>
      </div>
      <div class="col-8">
        <button mat-stroked-button class="pull-right me-3" (click)="closeDialog()">
          Cerrar
        </button>
        <button mat-stroked-button class="btn-convfact  me-3 pull-right" (click)="pay()">
          <mat-icon>save</mat-icon>
          {{ isEditMode === true ? 'Actualizar' : 'Añadir'}}
        </button>
      </div>

      <div class="col-4">
        <mat-form-field class="w-100 mb-2">
          <mat-label>Fecha</mat-label>
          <input matInput [matDatepicker]="Paided" placeholder="" name="constitucionPrestamos.fecha" required
            [(ngModel)]="constitucionPrestamos.fecha" />
          <mat-datepicker-toggle matSuffix [for]="Paided"></mat-datepicker-toggle>
          <mat-datepicker #Paided></mat-datepicker>
          <mat-error *ngIf="invalidDate">Campo requerido</mat-error>
        </mat-form-field>
      </div>

      <div class="col-4">
        <app-input inputType="text" placeholder="Concepto" [isRequired]="true"
          [(ngModel)]="constitucionPrestamos.concepto"></app-input>
      </div>
      <div class="col-4"></div>

      <div class="col-4">
        <mat-form-field class="w-100 mt-2 mb-2">
          <input type="text" matInput placeholder="Importe" [(ngModel)]="constitucionPrestamos.importe"
            value="constitucionPrestamos.importe" class="" required numberDecimalsDirective>
          <mat-error *ngIf="invalidImporte">Campo requerido</mat-error>
        </mat-form-field>
      </div>

      <div class="col-4">
        <mat-form-field class="w-100 mt-2 mb-2">
          <input type="text" matInput placeholder="Comisión Apertura"
            [(ngModel)]="constitucionPrestamos.comisionApertura" value="constitucionPrestamos.comisionApertura" class=""
            numberDecimalsDirective>
        </mat-form-field>
      </div>

      <div class="col-4">
        <mat-form-field class="w-100 mt-2 mb-2">
          <input type="text" matInput placeholder="Gastos Bancarios" [(ngModel)]="constitucionPrestamos.gastosBancarios"
            value="constitucionPrestamos.gastosBancarios" class="" numberDecimalsDirective>
        </mat-form-field>
      </div>
      <!-- Actividades -->
      <div class="col-4">
        <app-autocomplete-select [items]="activities" [(selectedItemId)]="constitucionPrestamos.activitiesUid"
          [idField]="'uid'" [displayField]="'name'" placeholder="Actividad">
        </app-autocomplete-select>
      </div>

      <div class="col-4">
        <app-autocomplete-select [items]="bankAccounts" [(selectedItemId)]="constitucionPrestamos.bankAccountsUid"
          [idField]="'uid'" [displayFields]="['bank', 'iban']" placeholder="Cuentas bancarias">
        </app-autocomplete-select>
      </div>

      <!-- Proyecto -->
      <div class="col-4" *ngIf="isProjectEnable && projects?.length > 0">
  <app-autocomplete-select
    [items]="projects"
    [(selectedItemId)]="constitucionPrestamos.projectUid"
    [idField]="'id'"
    [displayField]="'display'"
    placeholder="Proyecto"
    [classList]="'width90'">
  </app-autocomplete-select>
</div>

<div class="col-4"  *ngIf="isProjectEnable && expenseProjectTypes?.length > 0">
  <app-autocomplete-select
    [items]="expenseProjectTypes"
    [(selectedItemId)]="constitucionPrestamos.expenseProjectTypeUid"
    [idField]="'id'"
    [displayField]="'display'"
    placeholder="Tipo de proyecto de gasto"
    [classList]="'width90'">
  </app-autocomplete-select>
</div>


    </div>
  </ng-container>

  <div class="row" *ngIf="depositSaved === true">
    <div class="col-12">
      <div>Constitución {{ isEditMode === true ? 'actualizada': 'añadida' }} correctamente</div>
      <button mat-stroked-button class="mt-3" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
        Cerrar
      </button>
    </div>
  </div>

  <!-- Listado -->
  <div class="row" *ngIf="list == true">
    <div>
      <div class="fc-black mt-3">Listado</div>
    </div>

    <div class="movimiento-tarjeta-credito-listado">
      <app-table [columns]="headerTable" [dataSource]="dataSource" [hasSelect]="false" [hasButton]="true"
        [actionsTemplate]="actionsButtons">
      </app-table>
    </div>

    <ng-template #actionsButtons let-uid="uid">
      <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
        <ul class="custom-class">
          <li (click)="edit(uid)">
            <a>
              <mat-icon>create</mat-icon> Editar
            </a>
          </li>
          <li (click)="delete(uid)">
            <a>
              <mat-icon>warning</mat-icon> Borrar
            </a>
          </li>
        </ul>
      </ng-container>
    </ng-template>

  </div>

</ng-container>
